import { AnyAction } from 'redux';

import {
  getCurrentRouteName,
  getCurrentRouteParams,
  navigateTo,
} from '@neptune/shared/routing-business-logic';

import { NThunkAction } from 'state/types';

export function updateRouteParams(
  newParams: Record<string, unknown>,
): NThunkAction<void, AnyAction> {
  return (dispatch, getState) => {
    const routeName = getCurrentRouteName(getState());
    const routeParams = getCurrentRouteParams(getState());

    const newRouteParams = {
      ...routeParams,
      ...newParams,
    };

    dispatch(navigateTo(routeName, newRouteParams));
  };
}
